import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Theme,
    Tooltip,
    useMediaQuery,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BIN_ICON, EDIT_ICON, FILLED_PLUS_ICON } from '../../utils/Constants/ClassName';
import { useState } from 'react';
import { BulkAddBonusModal } from '../protivEmployeeBonusStatement/BulkAddBonusModal';
import { Confirm } from '../../components/Confirm';
import { useDeleteMany, useNotify } from 'react-admin';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import { PROPAY_STATUS } from '../../constants';
import { USER_TYPE } from '../../utils/Constants/ConstantData';


export const BonusResponsiveAdditionView = ({ additionalDetails,refreshData,data,identity }) => {
    const [openAddModal,setOpenAddModal]=useState(false);
    const [editAdditional,setEditAdditional] = useState({isOpen:false,id:NUMBER.ZERO,data:{}});
    const [deleteAdditional,setDeleteAdditional]=useState({isOpen:false,id:NUMBER.ZERO,type:''})
    const notify = useNotify();
    const shouldShowAction = data?.status !== PROPAY_STATUS.PAID && identity?.user_type !== USER_TYPE.worker
    const [deleteMany] = useDeleteMany('additionalPay',
        { ids: [deleteAdditional.id] },
        {
            onSuccess: () => {
                setDeleteAdditional({isOpen:false,id:NUMBER.ZERO,type:''})
                notify(`Additional ${deleteAdditional.type} deleted.`);
                refreshData && refreshData()
            },
            onError: (error: Error) => {
                notify(error.message)
                setDeleteAdditional({isOpen:false,id:NUMBER.ZERO,type:''})
            },
            mutationMode: 'pessimistic',
        }
    );
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const getPropayName = (propayObj: any) => {
        let parent = propayObj.parent_id
            ? propayObj.parent_id_obj.display_name
            : '';
        return parent
            ? parent + ` > ${propayObj.display_name}`
            : propayObj.display_name;
    };
    return (
        <div className="void-manager-bonus additional-bonus">
           {(shouldShowAction || additionalDetails?.length > NUMBER.ZERO) && <div className="void-manager-bonus-head">Additional {shouldShowAction ? <Button className='additional-add-btn' onClick={()=>{setOpenAddModal(true)}}> {FILLED_PLUS_ICON()} Add</Button>:''}</div>}
            {additionalDetails?.length > NUMBER.ZERO ?<div className="adjust-time-accordion">
                {additionalDetails.map(row => {
                    return (
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="additional1-content"
                                id="additional1-header"
                            >{row.propay_id ? getPropayName(row.propay_id_obj) : 'N/A'}{' '}
                               <span>
                                    {row.propay_id_obj.job_id_obj.id
                                        ? row.propay_id_obj.job_id_obj.full_name
                                        : ''}
                                </span>
                                {row.additional_deduction_amt ? (
                                    <Button className="overage-btn-bonus">
                                        Deduction
                                    </Button>
                                ) : (
                                    row.additional_bonus_amt && (
                                        <Button className="btn-bonus-green">
                                            Bonus
                                        </Button>
                                    )
                                )}
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="bonus-accordion-item">
                                    <span className="bonus-accordion-label">
                                        Description
                                    </span>
                                    {row.description}
                                </div>
                                <div className="bonus-accordion-item">
                                    <span className="bonus-accordion-label">
                                        Amount
                                    </span>
                                    {row.additional_deduction_amt
                                        ? `(${formatter.format(
                                              row.additional_deduction_amt
                                          )})`
                                        : formatter.format(row.additional_bonus_amt)}
                                </div>
                                {shouldShowAction ? <div className="bonus-action-icons">
                                    <Tooltip
                                        title="Edit"
                                        className='additional-edit-icon'
                                        arrow
                                        placement="top"
                                        onClick={()=>setEditAdditional({isOpen:true,data:row,id:row.additional_pay_ids[NUMBER.ZERO]})}
                                    >
                                       {EDIT_ICON()}
                                    </Tooltip>
                                    <Tooltip
                                        title="Delete"
                                        className='additional-deleted-icon'
                                        arrow
                                        placement="top"
                                        onClick={()=>setDeleteAdditional({isOpen:true,id:row.additional_pay_ids[NUMBER.ZERO],type:row.additional_deduction_amt ? 'deduction':'bonus'})
                                    }>
                                    {BIN_ICON()}
                                   </Tooltip>
                                </div>:''}
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
                {openAddModal && <BulkAddBonusModal isOpen={openAddModal} refreshData={refreshData} onClose={()=>{setOpenAddModal(false)}} selectedIds={[data.id]} showOption={true} recordId={data.id}/>}
                {(editAdditional.isOpen) && <BulkAddBonusModal editData={editAdditional.data} isEdit={true} isOpen={editAdditional.isOpen} refreshData={()=>{}} onClose={()=>{setEditAdditional({isOpen:false,id:NUMBER.ZERO,data:{}})}} 
                                    selectedIds={[editAdditional.id]} bulkAction={editAdditional.data['additional_deduction_amt'] ? 'deduction':'bonus'} showOption={false} recordId={editAdditional.id}/>}
                  {deleteAdditional.isOpen && <Confirm
                    isOpen={deleteAdditional.isOpen}
                    title={`Delete ${deleteAdditional.type}`} 
                    content={`Are you sure you want to delete ${deleteAdditional.type} `}
                    onConfirm={()=>{deleteMany()}}
                    onClose={() => {setDeleteAdditional({isOpen:false,id:NUMBER.ZERO,type:''})}}                    
                    />}
            </div>:''}
        </div>
    );
};
export default BonusResponsiveAdditionView;
